import { use } from 'react'

import { DataGridContext } from '../context/DataGridContext'

export function useDataGridContext() {
    const context = use(DataGridContext)
    if (!context) {
        throw new Error('useDataGridContext must be used within a KeyboardNavigationProvider')
    }
    return context
}
